import { action, computed } from 'mobx';
import { Model } from 'core/model/Model';
import type { ModelBase } from 'core/model/model.types';
import type { RBACString } from '@kentik/ui-shared/rbac/constants';

export interface RbacPermAttributes extends ModelBase {
  group: string;
  permission: RBACString;
  display: string;
  labelFilter?: boolean;
  isEnabled?: boolean;
  labelBasedAccess?: boolean;
  label_metadata?: number[];
}

export default class RbacPermModel extends Model<RbacPermAttributes> {
  @action
  setLabelBasedAccess(newValue: boolean) {
    this.set('labelBasedAccess', newValue);
    if (!newValue) {
      this.set('label_metadata', []);
    }
  }

  @computed
  get isLabelBasedAccess() {
    if (this.get('labelBasedAccess') !== undefined) {
      return this.get('labelBasedAccess');
    }

    if (this.get('label_metadata')?.length) {
      return true;
    }
    return false;
  }

  @computed
  get groupLabels() {
    const labels = new Set<number>();
    // I'm not understanding how this works, but it seems calling this.collection.each causes  adjacent rows to rerender.
    // Hencing achieving update labels in one row also updates group labels in another row.
    this.collection?.each((perm) => {
      const label_metadata = perm.get('label_metadata');
      if (perm.get('group') === this.get('group') && Array.isArray(label_metadata)) {
        label_metadata.forEach((l) => labels.add(l));
      }
    });
    return [...labels];
  }
}
